import { useAuthState } from "@/contexts/auth/auth.provider";
import { useMutation } from "@apollo/client";
import { INIT_WHATSAPP_PROJECT_LOCATION } from "@/graphql/mutations/user";
import { isSafari } from "@/lib/browserHelpers";
import { ErrorModal } from "@/components/error/ssr";

const useRequestProjectLocation = (projectId) => {
  const { token } = useAuthState();

  const [requestProjectLocation, { loading: requestLocationLoading }] =
    useMutation(INIT_WHATSAPP_PROJECT_LOCATION, {
      context: { token },
      variables: {
        project_id: projectId,
        language: "ar",
      },
      onCompleted: (data) => {
        if (data?.User?.initWhatsappUserRequestProjectLocation) {
          const { redirect_url } =
            data.User.initWhatsappUserRequestProjectLocation;
          if (isSafari()) {
            window.location.href = redirect_url;
          } else {
            window.open(redirect_url, "_blank");
          }
        } else {
          ErrorModal.handle({
            message: "فشل في فتح الواتساب",
          });
        }
      },
      onError: (error) => {
        ErrorModal.handle({
          message: error?.message || "فشل في فتح الواتساب",
        });
      },
    });

  const handleRequestLocation = () => {
    if (requestLocationLoading) {
      return;
    }
    return requestProjectLocation();
  };

  return {
    handleRequestLocation,
    requestLocationLoading,
  };
};

export default useRequestProjectLocation;
